module.exports = __webpack_public_path__ + "media/svg-new/doc-cf60d0ab.svg";